<template>
  <div class="wrapper">
    <div class="contact">
      <img src="../assets/runner.gif" class="runner-gif"/>
      <p>If you have questions,<p>
      <p>or would like to volunteer to help out,</p>
      <p>please contact <em>Bruce</em> and <em>Sam</em> at:</p>
      <div class="contact-email"><em><strong>thebonningtonbeast@gmail.com</strong></em></div>

      <div style="margin-top: 100px">Website design and development by Sam MacKinnon.</div>
      <p><em><strong>sam.w.mackinnon@gmail.com</strong></em></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contact .contact-email {
  font-size: 20px;
  margin-top: 0;
  font-weight: 500;
  margin-bottom: 0;
  margin-top: 10px;
}
.contact p {
  font-size: 18px;
  margin: 0;
}
.contact {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.runner-gif {
  margin-bottom: 20px;
  width: 100px;
  height: 100px;
}
</style>
